export const appLinkConstants = {
    gesamtbetriebsvereinbarungLink: 'https://soc.siemens.cloud/c/ar8slx',
    nextWorkLink: 'https://siemens.sharepoint.com/sites/NextWork/en/SitePages/Home.aspx',
    learningAndGrowthLink: 'https://mylearningworld.siemens.com/web/de/app/toc/lex_auth_01348007617684275266/overview',
    powerPointTemplateLink:
        'https://siemens.sharepoint.com/:p:/t/EC-Team75/IQA7IyqofU3rRbDOT14CfZGgAVj0OsXGQ7cBamn4D4Hohh8',
    excelTemplateLink: 'https://siemens.sharepoint.com/:x:/t/EC-Team75/IQDgXrTuyEdfR69-vc8QUWh_AXmn4tDWsrcdSvIO-njtETM',
    contactLink: 'mailto:transformationsfonds.de@siemens.com',
    chatbotLink:
        'https://chat.siemens.com/00000000-0000-0000-0000-000000000000/library/agents/bd282f36-8a25-49d2-80f4-6518fedb0115',
    toolsAndResourcesLink:
        'https://siemens.sharepoint.com/:f:/t/EC-Team75/IgCtpml3VneVQrUGgbxQXOe-AcW5tsUNqDcPXrTb0Wrk_cU?e=GZ1YFG&xsdata=MDV8MDJ8fDA3ZTExMmQ0OWQ1ZjQwNzliMGJhMDhkZTYzMTMyMjE2fDM4YWUzYmNkOTU3OTRmZDRhZGRhYjQyZTE0OTVkNTVhfDB8MHw2MzkwNTcxMzA5NjA2Mjk5NDZ8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T21FMk5tSmtOak00TkdVMVlUUmtabUU1TUdZMk56bGpaRGxsWmprNFpETmpRSFJvY21WaFpDNTJNaTl0WlhOellXZGxjeTh4Tnpjd01URTJNamswTURRMHxiNTUyNWMxZTc1NzM0NmRlMTQwNDA4ZGU2MzEzMjIxNnxmNzBkODU1ZWZlYjY0ZTJjYjViNzllYTk1ODA4MWViOA%3D%3D&sdata=SGtJbTBkN0tLMGNENDVYaVQzNkdWL3Z3bGRqZUM4YXNjZTdzK1Vvb002TT0%3D&ovuser=38ae3bcd-9579-4fd4-adda-b42e1495d55a%2Ckatharina.brand%40siemens.com'
};

export const customerLinkConstants = {
    customerApplyRoute: '/apply',
    customerFaqRoute: '/faq',
    customerDeadlinesRoute: '/#dates-deadlines'
};

export const managementLinkConstants = {};
